module.exports = __webpack_public_path__ + "static/media/temp-persona-13.6221a10d.jpg";